<div id="contact-form-compact-container">
    <div id="contact-form-general-container">
        <h3 class="subtitle contact-title">Contáctanos</h3>
        <p class="description">Rellene el siguiente formulario para ponerse en contacto con uno de nuestros expertos del programa de drones.</p>
        <form #contactForm="ngForm" (ngSubmit)="sendContactEmail()">
            <label for="contact-msg">
                <span class="label-field">Su mensaje *</span>
                 <textarea name="msg" id="contact-msg" maxlength="255" minlength="10" required #contactMessage="ngModel" [(ngModel)]="info.msg"></textarea>
                 @if (contactMessage.invalid && contactMessage.touched ) {
                    <span class="error-msg">Campo requerido</span>
                    @if (contactMessage.errors?.['minlength']) {
                        <span class="error-msg">Longitud insuficiente</span>
                    }
                 } 
            </label>

            <div class="contact-fields-container">
                <label for="contact-name" class="left-field">
                    <span class="label-field">Su nombre *</span>
                    <input type="text" name="contact-name" id="contact-name" minlength="1" #contactName="ngModel" [(ngModel)]="info.name" required>
                    @if (contactName.invalid && contactName.touched) {
                        <span class="error-msg">Campo requerido</span>
                    }
                    
                </label>
                <label for="contact-email" class="right-field">
                    <span class="label-field">Su correo electrónico *</span>
                    <input type="email" email name="contact-email" id="contact-email" required #contactEmail="ngModel" [(ngModel)]="info.email">
                    @if(contactEmail.touched && contactEmail.errors?.['required']) {
                        <span class="error-msg">Campo requerido</span>
                    } 
                    @if (contactEmail.touched && contactEmail.errors?.['email']) {
                        <span class="error-msg">Formato inválido</span>
                    }
                </label>
            </div>
            <div class="contact-fields-container">
                <label for="contact-sector" class="left-field">
                    <span class="label-field">Sector *</span>
                     <select name="contact-sector" id="contact-sector" #contactSector="ngModel" [(ngModel)]="info.sector">
                        <option value="">Sector</option>
                        @for (sector of sectorList; track $index) {
                            <option [value]="sector.value">{{sector.label}}</option>
                        }
                     </select>

                    @if(contactSector.value === '' && contactSector.touched) {
                        <span class="error-msg">Campo requerido</span>
                    }

                </label>
                <label for="contact-company" class="right-field">
                    <span class="label-field">Su empresa *</span>
                    <input type="text" name="contact-company" id="contact-company" required #contactCompany="ngModel" [(ngModel)]="info.company">

                    @if(contactCompany.invalid && contactCompany.touched) {
                        <span class="error-msg">Campo requerido</span>
                    }

                </label>
            </div>
            <div class="contact-fields-container">
                <label for="contact-province" class="left-field">
                    <span class="label-field">Estado o provincia *</span>
                     <select name="contact-province" id="contact-province" #contactProvince="ngModel" [(ngModel)]="info.province">
                        <option value="">Estado o provincia</option>
                        @for (province of provinceList; track $index) {
                            <option [value]="province.value">{{province.label}}</option>
                        }
                     </select>

                    @if(contactProvince.value === '' && contactProvince.touched) {
                        <span class="error-msg">Campo requerido</span>
                    }
                </label>
                <label for="contact-tlf" class="right-field">
                    <span class="label-field">Número de contacto *</span>
                    <input type="tel" name="contact-tlf" id="contact-tlf" pattern="^(?:\+(?:34|351)\s?)?[6-9]\d{2}\s?\d{3}\s?\d{3}$" tel required #contactTlf="ngModel" [(ngModel)]="info.tlf">

                    @if (contactTlf.invalid && contactTlf.touched) {
                        @if (contactTlf.errors?.['required']) {
                            <span class="error-msg">Campo requerido</span>
                        }
                        @if (contactTlf.errors?.['pattern']) {
                            <span class="error-msg">Introduzca un número de teléfono válido</span>
                        }
                    }
                </label>
            </div>
            

            <label for="contact-accept" id="contact-checkbox-label">
                <div id="contact-checkbox-label-fields">
                    <input type="checkbox" checked name="contact-accept" id="contact-accept" required #contactAccept="ngModel" [(ngModel)]="info.accept">
                    <span>
                        Acepto la <a href="/security-policy" target="_blank">Política de seguridad</a> y la <a href="/cookie-policy" target="_blank">Política de cookies</a> de DJI *
                    </span>
                </div>
                @if (contactAccept.invalid) {
                    <span class="error-msg">Campo requerido</span>
                }
            </label>

            <button type="submit" [disabled]="contactForm.invalid || isSendingRequest">Enviar</button>
        </form>
        
        @if (showErrorMsg) {
            <div class="error-msg">Lo sentimos, ha habido un error. Inténtelo de nuevo más tarde.</div>
        }

        @if (showSuccessMsg) {
            <div class="success-msg">¡Muchas gracias! En breve nos pondremos en contacto con usted.</div>
        }
    </div>
</div>

